import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import twitter1 from '../assets/twitter1.png'
import facebook1 from '../assets/facebook1.png'
import youtube1 from '../assets/youtube1.png'
import instagram from '../assets/instagram.png'

export function Footer() {
  return (
    <Container id="footer" fluid>
        <Row className='bg-dark py-4'>

        <Col sm={4} className='text-white'>
              <h6>Address:</h6>
              <p>S.C.B No. 8-8-120,Doveton Bazar,Bollarum,Secunderabad-10</p>
            </Col>
        <Col sm={4} className='text-white'>
        <h6>Stay Connected</h6>
        <a href='https://www.facebook.com/profile.php?id=100084688486447&mibextid=ZbWKwL' target='_blank'><img src={facebook1} className='px-2' /></a>
        <img src={twitter1} className='px-2' />
        <a href='https://www.youtube.com/@srivenugopalaswamytemple-b3648' target='_blank'><img src={youtube1} className='px-2' /></a>
        <img src={instagram} className='px-2' />
        </Col>
        <Col sm={4}>
        <a href ='https://merchant.razorpay.com/policy/Mf0hhcuVQhrLNK/terms' className='text-white'>Terms and Conditions</a>
        <br/>
        <a href='https://merchant.razorpay.com/policy/Mf0hhcuVQhrLNK/contact_us' className='text-white'>Contact Us</a>
        <br/>
        <a href='https://merchant.razorpay.com/policy/Mf0hhcuVQhrLNK/refund' className='text-white'>Cancellation and Refund Policy</a>
        <br/>
        <a href='https://merchant.razorpay.com/policy/Mf0hhcuVQhrLNK/privacy' className='text-white'>Privacy Policy</a>
        <br/>
        <a href='https://merchant.razorpay.com/policy/Mf0hhcuVQhrLNK/shipping' className='text-white'>Shipping and Delivery Policy</a>
        
        </Col>

        </Row>

<Row className='bg-dark border-top'>
<Col className='text-white text-center' sm={12}>
            <p>Copyright &copy; Sri Venugopala Swamy Temple Trust</p>

            </Col>
</Row>
        
    </Container>
  )
}
